import { makeStyles, ThemeProvider } from '@ui';
import { Card, CardActions, CardContent, IconButton, Typography } from '@ui/components';
import { ForumIcon } from '@ui/icons';
import React from 'react';
import { usePaymentProviderContext } from '../../Session';
import { formatInCurrency } from '../common';
import { useMetricsQuery } from './useMetricsQuery';

const useStyles = makeStyles(({ palette }) => ({
  card: { width: '466px', minHeight: '163px' },
  button: {
    transition: 'color .15s',
    color: palette.primary.main,
    '&.Mui-disabled': { color: palette.action.active },
  },
}));

export const UnappliedCredits: React.FC = () => {
  const { unappliedBalance } = useMetricsQuery();
  const { currencyOptions } = usePaymentProviderContext();
  const classes = useStyles();

  return (
    <ThemeProvider>
      <Card classes={{ root: classes.card }}>
        <CardContent>
          <Typography variant='h3' color='textPrimary' gutterBottom>
            Available Unapplied Credits
          </Typography>

          <Typography variant='body2' color='textPrimary'>
            Note: All available unapplied credits or unassigned payments can be added only via
            contacting the Licensing team.
          </Typography>
        </CardContent>

        <CardActions disableSpacing>
          <Typography variant='body1' color='textPrimary'>
            {currencyOptions.currency} {formatInCurrency(unappliedBalance, currencyOptions)}
          </Typography>

          <IconButton
            component='a'
            disabled={!unappliedBalance}
            classes={{ root: classes.button }}
            href='https://enscape3d.com/contact'
            target='_blank'
            rel='noreferrer noopener'
          >
            <ForumIcon />
          </IconButton>
        </CardActions>
      </Card>
    </ThemeProvider>
  );
};
